import { MessageBox } from "element-ui";
import { validateCategoryForm } from "../models/categoryParams";

/**
 * Shared save flow for the category create/detail pages: validate the form,
 * optionally confirm, then run the page-provided `save()` and navigate back to
 * the list. Components using this mixin must:
 *   - expose a `form` (validated by `validateCategoryForm`),
 *   - implement a `save()` method that performs the create/update request,
 *   - set `confirmBeforeSave: true` when a confirmation dialog is required
 *     (defaults to false).
 */
export default {
  data() {
    return {
      isSaving: false,
      confirmBeforeSave: false
    };
  },
  methods: {
    async handleClickSave() {
      if (this.isSaving) {
        return;
      }

      const validationError = validateCategoryForm(this.form);
      if (validationError) {
        this.$message.error(validationError);
        return;
      }

      if (this.confirmBeforeSave) {
        try {
          await MessageBox.confirm("ยืนยันการบันทึก", {
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก"
          });
        } catch (e) {
          return;
        }
      }

      this.isSaving = true;

      try {
        await this.save();
        this.$router.push({ name: "RuejaiClubCategoryListPage" });
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      } finally {
        this.isSaving = false;
      }
    }
  }
};
